var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EnergyVisualisation',{staticStyle:{"width":"650px","height":"650px"},attrs:{"circles-display-data":_vm.circlesDisplayData,"lines-display-data":_vm.linesDisplayData}})
}
var staticRenderFns = []

export { render, staticRenderFns }